/**
 * Rutas de la aplicación — centralizadas para evitar magic strings.
 * Patrón multi-tenant: URL incluye empresa_id en `/e/:empresaId/...`
 * (ver D02).
 */

export const routes = {
  login: '/login',
  selectEmpresa: '/select-empresa',
  empresa: {
    root: (empresaId: string) => `/e/${empresaId}`,
    dashboard: (empresaId: string) => `/e/${empresaId}/dashboard`,
    clientes: {
      administraciones: (empresaId: string) =>
        `/e/${empresaId}/clientes/administraciones`,
      edificios: (empresaId: string) => `/e/${empresaId}/clientes/edificios`,
    },
    controlAbonos: (empresaId: string) => `/e/${empresaId}/control-abonos`,
    finanzas: (empresaId: string) => `/e/${empresaId}/finanzas`,
    facturacion: (empresaId: string) => `/e/${empresaId}/facturacion`,
    recupero: (empresaId: string) => `/e/${empresaId}/recupero`,
    conciliacion: (empresaId: string) => `/e/${empresaId}/conciliacion`,
    reportes: (empresaId: string) => `/e/${empresaId}/reportes`,
    configuracion: (empresaId: string) => `/e/${empresaId}/configuracion`,
    usuarios: (empresaId: string) => `/e/${empresaId}/usuarios`,
    perfil: (empresaId: string) => `/e/${empresaId}/mi-perfil`,
  },
} as const;
